module.exports = __webpack_public_path__ + "static/lion-0344d748189ec2c5c9e4422edcd6a17e.mp4";